<template>
  <div class="p-override-select-button">
    <p-vue-select-button v-bind="$attrs"></p-vue-select-button>
  </div>
</template>

<style scoped>
.p-override-select-button:deep(.p-selectbutton .p-button) {
  background: var(--color-success);
  border: none;
}

.p-override-select-button:deep(.p-selectbutton .p-button.p-highlight) {
  background-color: var(--color-success-active);
}

.p-override-select-button:deep(.p-buttonset .p-button:first-of-type) {
  border-top-left-radius: 2rem;
  border-bottom-left-radius: 2rem;
  margin-right: 1px;
}

.p-override-select-button:deep(.p-buttonset .p-button:last-of-type) {
  border-top-right-radius: 2rem;
  border-bottom-right-radius: 2rem;
  margin-left: 1px;
}

.p-override-select-button :deep(.p-selectbutton) {
  direction: ltr;
}

.p-override-select-button {
  margin: auto;
}
</style>
